<template>
    <b-modal v-model="isShowPopup" dialog-class="modal-detail" @hidden="resetModal" scrollable :no-close-on-backdrop=true id="popup-upload" @ok="uploadButtonAction" :okTitle="okTitle" title="Upload Data">
        <b-card>
            <b-row>
                <b-col cols="12">
                    <app-input-fileupload label="File" size="sm" :model.sync="fileupload" />
                </b-col>
            </b-row>
            <b-row v-if="isUploadSuccess">
                <b-col cols="12">
					<b-card no-body>
						<b-tabs card>
							                            <b-tab title="Upload Combine Case" active>

                                <b-row v-if="hasFailedDataCombineCase">
                                    <b-col>
                                        <b-button variant="danger" v-b-toggle.failed-content class="m-1">Invalid Data ({{ totalFailedCombineCase.toLocaleString() }})</b-button>
                                        <b-collapse visible id="failed-content">
                                            <div class="table-corner">
                                                <b-table id="failed-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="combineCasesFailed" :fields="fieldsCombineCase" :busy="isDataLoading"
                                                         :sort-by.sync="sortByCombineCase" :sort-desc.sync="sortDescCombineCase" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>
												<template #cell(combineDate)="row">
													{{ row.item.combineDate | moment("DD-MMM-YYYY") }}
												</template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                                <b-row>
                                    <b-col>
                                        <b-button variant="success" v-b-toggle.success-content class="m-1">Valid Data ({{ totalSucceedCombineCase.toLocaleString() }})</b-button>
                                        <b-collapse id="success-content">
                                            <div class="table-corner">
                                                <b-table id="success-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="combineCases" :fields="fieldsCombineCase" :busy="isDataLoading"
                                                         :sort-by.sync="sortByCombineCase" :sort-desc.sync="sortDescCombineCase" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>
												<template #cell(combineDate)="row">
													{{ row.item.combineDate | moment("DD-MMM-YYYY") }}
												</template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                            </b-tab>                            <b-tab title="Upload Combine Case Detail" active>

                                <b-row v-if="hasFailedDataCombineCaseDetail">
                                    <b-col>
                                        <b-button variant="danger" v-b-toggle.failed-content class="m-1">Invalid Data ({{ totalFailedCombineCaseDetail.toLocaleString() }})</b-button>
                                        <b-collapse visible id="failed-content">
                                            <div class="table-corner">
                                                <b-table id="failed-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="combineCaseDetailsFailed" :fields="fieldsCombineCaseDetail" :busy="isDataLoading"
                                                         :sort-by.sync="sortByCombineCaseDetail" :sort-desc.sync="sortDescCombineCaseDetail" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>
												<template #cell(qtyControlCard)="row">
													{{ Number(row.item.qtyControlCard).toLocaleString() }}
												</template>
												<template #cell(qtyAfter)="row">
													{{ Number(row.item.qtyAfter).toLocaleString() }}
												</template>
												<template #cell(takenQty)="row">
													{{ Number(row.item.takenQty).toLocaleString() }}
												</template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                                <b-row>
                                    <b-col>
                                        <b-button variant="success" v-b-toggle.success-content class="m-1">Valid Data ({{ totalSucceedCombineCaseDetail.toLocaleString() }})</b-button>
                                        <b-collapse id="success-content">
                                            <div class="table-corner">
                                                <b-table id="success-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="combineCaseDetails" :fields="fieldsCombineCaseDetail" :busy="isDataLoading"
                                                         :sort-by.sync="sortByCombineCaseDetail" :sort-desc.sync="sortDescCombineCaseDetail" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>
												<template #cell(qtyControlCard)="row">
													{{ Number(row.item.qtyControlCard).toLocaleString() }}
												</template>
												<template #cell(qtyAfter)="row">
													{{ Number(row.item.qtyAfter).toLocaleString() }}
												</template>
												<template #cell(takenQty)="row">
													{{ Number(row.item.takenQty).toLocaleString() }}
												</template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                            </b-tab>

						</b-tabs>
					</b-card>
                </b-col>
            </b-row>
        </b-card>
        <template #modal-footer="{ ok, cancel }">
            <b-button v-if="isUploadSuccess" size="sm" variant="primary" @click="downloadLog()">
                Download Log
            </b-button>
            <b-button size="sm" variant="success" class="float-right" @click="ok()">
                {{ okTitle }}
            </b-button>
            <b-button size="sm" variant="secondary" class="float-right" @click="cancel()">
                Cancel
            </b-button>
        </template>
        <b-overlay :show="isBusy" no-wrap></b-overlay>
    </b-modal>
</template>
<style lang="scss" scoped>
    .card {
        border: 1px solid rgba(0, 0, 0, 0.125) !important;
    }

    ::v-deep.th-message {
        color: red;
    }

    ::v-deep.modal-footer {
        display: block;
    }
</style>
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import { saveAs } from 'file-saver';

import CombineCase from '@/models/CombineCase/CombineCase';
import CombineCaseList from '@/models/CombineCase/CombineCaseList';
import CombineCaseFilter from '@/filters/CombineCase/CombineCaseFilter';

import AppInputFileupload from '@/components/AppInputFileupload';

export default {
	props: ['model', 'openPopup','uploadButtonMethod', 'parentId'],
	components : {AppInputFileupload,},
	data() {
		return {
			fileupload: null,
			uploadProcessId: null,
			datas: Array(),
			fieldsCombineCase: [
				// {"no" : { "class" : "th-number"}},
				{"class" : "th-id", "label" : "Excel Row", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Id", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Combine Date", key: 'combineDate', sortable: false},
				{"class" : "th-status", "label" : "Control Card", key: 'controlCardControlCardNumber', sortable: false},
				{"class" : "th-status", "label" : "Part", key: 'partPartNumber', sortable: false},

				{"class" : "th-status", "label" : "Status", key: 'uploadValidationStatus', sortable: false},
				{"class" : "th-message", "label" : "Message", key: 'uploadValidationMessageHtml', sortable: false},
				{"actions": { "class" : "th-actions", "label" : "" }}
			],
			fieldsCombineCaseDetail: [
				// {"no" : { "class" : "th-number"}},
				{"class" : "th-id", "label" : "Excel Row", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Id", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Control Card", key: 'controlCardControlCardNumber', sortable: false},
				{"class" : "th-status", "label" : "Qty", key: 'qtyControlCard', sortable: false},
				{"class" : "th-status", "label" : "Qty After", key: 'qtyAfter', sortable: false},
				{"class" : "th-status", "label" : "Taken Qty", key: 'takenQty', sortable: false},

				{"class" : "th-status", "label" : "Status", key: 'uploadValidationStatus', sortable: false},
				{"class" : "th-message", "label" : "Message", key: 'uploadValidationMessageHtml', sortable: false},
				{"actions": { "class" : "th-actions", "label" : "" }}
			],

			busy:false,
			isDataLoading: false,
			isBusy : false,
			combineCases : [],
			combineCasesFailed: [],
			combineCaseId : '',
			sortByCombineCase: '',
			sortDescCombineCase: '',
			hasFailedDataCombineCase: false,
			totalFailedCombineCase: 0,
			totalSucceedCombineCase: 0,
			combineCaseDetails : [],
			combineCaseDetailsFailed: [],
			combineCaseDetailId : '',
			sortByCombineCaseDetail: '',
			sortDescCombineCaseDetail: '',
			hasFailedDataCombineCaseDetail: false,
			totalFailedCombineCaseDetail: 0,
			totalSucceedCombineCaseDetail: 0,


			processId: '',
			isUploadSuccess: false,
		}
	},
	methods : {
		resetModal() {
			this.datas = Array();
			this.isUploadSuccess = false;
			this.$emit('resetMethod');
		},
		uploadButtonAction(modalEvent) {
			modalEvent.preventDefault();
			this.isBusy = true;
			if (this.isUploadSuccess) {
				let _this = this;
				this.$http.post('combinecase/confirmUpload/' + _this.uploadProcessId,
					[],
					).then(async function(response){
						if (response != null) {
							if (response.data != null) {
								_this.resetModal();
								_this.datas = Array();
								_this.fileupload = null;
								_this.isUploadSuccess = false;
							}
						}
						_this.isBusy = false;
					})
					.catch(error => {
						_this.$store.dispatch('addErrorMessageGlobal', error);
						_this.isBusy = false;
					});
			} else {
				if (this.fileupload != null) {
					let data = new FormData();
					data.append('file', this.fileupload);
					let _this = this;
					this.$http.post('combinecase/upload',
						data,
						{ headers: { 'Content-Type': 'multipart/form-data' } }
					).then(async function(response){
						_this.uploadProcessId = response.data.id;
						_this.isUploadSuccess = true;
						await _this.getCombineCaseForUpload();
					})
					.catch(error => {
						_this.$store.dispatch('addErrorMessageGlobal', error);
						_this.isBusy = false;
					});
				}
			}
		},
		getCombineCaseForUpload : async function() {
			let _this = this;
			this.$http.get('combinecase/uploadresult/' + _this.uploadProcessId)
				.then(async function(response) {
					_this.combineCases = [];
_this.combineCaseDetails = [];


					if (response != null) {
						let result = response.data;
						_this.combineCases = result.filter(o => { return o.uploadValidationStatus == "Success"});
                        _this.totalSucceedCombineCase = _this.combineCases.length;

						_this.combineCasesFailed = result.filter(o => { return o.uploadValidationStatus != "Success"});
						_this.hasFailedDataCombineCase = true;
						_this.totalFailedCombineCase = 0;
						if(_this.combineCasesFailed == undefined || _this.combineCasesFailed.length === 0) _this.hasFailedDataCombineCase = false;
						if(_this.hasFailedDataCombineCase) _this.totalFailedCombineCase = _this.combineCasesFailed.length;
						_this.combineCaseDetails = [];
						_this.combineCaseDetailsFailed = [];
						_this.hasFailedDataCombineCaseDetail = true;
						_this.totalSucceedCombineCaseDetail = 0;
						result.forEach(function(element) {
							_this.combineCaseDetails.push(...element.combineCaseDetail.filter(o => { return o.uploadValidationStatus == "Success"}));
							_this.totalSucceedCombineCaseDetail = _this.combineCaseDetails.length;

							_this.combineCaseDetailsFailed.push(...element.combineCaseDetail.filter(o => { return o.uploadValidationStatus != "Success"}));
							if(_this.combineCaseDetailsFailed == undefined || _this.combineCaseDetailsFailed.length === 0) _this.hasFailedDataCombineCaseDetail = false;
							if(_this.hasFailedDataCombineCaseDetail) _this.totalFailedCombineCaseDetail = _this.combineCaseDetailsFailed.length;
						});
						_this.isBusy = false;
					}
				})
				.catch(error => {
					_this.$store.dispatch('addErrorMessageGlobal', error);
					_this.isBusy = false;
				});
		},
		downloadLog() {
			let _this = this;
			let url = 'combinecase/downloadlog/' + _this.uploadProcessId;
			this.$http.get(url, {responseType: 'blob'}).then(async response => {
				if (response != null) {
					await saveAs(response.data, 'CombineCase.xlsx');
				}
			}).catch(error => {
				this.$store.dispatch('addErrorMessageGlobal', error);
				throw error;
			});
		}
	},
	beforeMount() {
	},
	mounted(){
	},
	watch: {
		fileupload(newValue, oldValue) {
			this.datas = Array();
			this.isUploadSuccess = false;
		}
	},
	computed: {
		okTitle: {
			get: function() {
				if (this.isUploadSuccess) {
					return "Process";
				}
				return "Upload";
				}
		},
		isShowPopup : {
			get: function () {
				if (this.openPopup) {
					this.filterCombineCase = new CombineCaseFilter();
					return true;
				}
				else return false;
			},
			set: function (newValue) {}
		},
	}
}
</script>
